import { matchRegex } from "@models/regex";

export const matchUrlPath = (pathname: string, matches: RegExp[]): boolean => {
  for (const match of matches) {
    if (matchRegex(match, pathname)) return true;
  }
  return false;
};
